module.exports = __webpack_public_path__ + "static/media/details-1.17d6ad11.jpeg";